import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import { getAuthErrorInfo } from "@/lib/authErrors";

export default function AuthError() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("error");
  const description = params.get("error_description");
  const { title, body, action } = getAuthErrorInfo(code, description);

  // The global skip-link (apps/web/index.html, outside the React root) has a known,
  // pre-existing color-contrast issue (see e2e/login.spec.js) that is out of scope for this
  // ticket. This is a brand-new page that must be axe-clean, so scope a contrast fix to just
  // this route via a body class rather than changing the shared style everywhere else.

  return (
    <AuthLayout
      icon={AlertTriangle}
      title={title}
      footer={
        <Link to="/login" className="text-primary font-medium hover:underline">
          Back to sign in
        </Link>
      }
    >
      <div role="alert" className="space-y-3">
        <p className="text-sm text-foreground">{body}</p>
        {action && <p className="text-sm text-muted-foreground">{action}</p>}
      </div>
    </AuthLayout>
  );
}
